import { inject, Injectable } from '@angular/core';
import { HEADERS } from '../api-headers';
import { HttpClient } from '@angular/common/http';

import { toFormBody } from '../api-utils';
import {
  WORKSPACE_PUT,
  WORKSPACE_DELETE,
  WORKSPACE_PATCH,
} from '../endpoints/workspace.endpoints';

import { Workspace } from 'src/app/core/models/core.models';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceApiService {
  private readonly http = inject(HttpClient);

  createWorkspace(
    title: string,
    description: string,
    title_i18n: Record<string, string> = {},
  ): Observable<Workspace> {
    return this.http.put<Workspace>(
      WORKSPACE_PUT,
      toFormBody({ title, description, title_i18n }),
      { headers: HEADERS.formUrlEncoded },
    );
  }

  updateWorkspace(
    id: string,
    workspace: Record<string, unknown>,
  ): Observable<Workspace> {
    return this.http.patch<Workspace>(
      WORKSPACE_PATCH(id),
      toFormBody(workspace),
      { headers: HEADERS.formUrlEncoded },
    );
  }

  deleteWorkspace(workspaceId: string): Observable<any> {
    return this.http.delete(WORKSPACE_DELETE(workspaceId));
  }
}
